module.exports = __webpack_public_path__ + "img/billing.b17c4f79.svg";